import {
  VALIDATION_MESSAGES,
  REGEX_PATTERNS,
  VALIDATORS,
} from '../../../utils/validationMessages';

export interface ManagerFormInput {
  name: string;
  email: string;
  accountNumber: string;
  performanceFee: number;
  managementFee: number;
  leverage: string;
  riskLevel: string;
}

export function validateManagerForm(
  data: Partial<ManagerFormInput>
): Record<string, string> {
  const errors: Record<string, string> = {};

  if (!data.name?.trim()) {
    errors.name = VALIDATION_MESSAGES.fullName.required;
  } else if (data.name.trim().length < 2) {
    errors.name = VALIDATION_MESSAGES.fullName.minLength;
  } else if (data.name.trim().length > 50) {
    errors.name = VALIDATION_MESSAGES.fullName.maxLength;
  } else if (!/^[a-zA-Z \-']+$/.test(data.name.trim())) {
    errors.name = VALIDATION_MESSAGES.fullName.pattern;
  }

  if (!data.email?.trim()) {
    errors.email = VALIDATION_MESSAGES.email.required;
  } else if (
    !REGEX_PATTERNS.email.test(data.email.trim()) ||
    !VALIDATORS.email(data.email.trim())
  ) {
    errors.email = VALIDATION_MESSAGES.email.invalid;
  } else if (data.email.trim().length > 100) {
    errors.email = VALIDATION_MESSAGES.email.maxLength;
  }

  if (!data.accountNumber?.trim())
    errors.accountNumber = 'Trading Account Number is required';
  if (
    data.performanceFee === undefined ||
    data.performanceFee < 0 ||
    data.performanceFee > 100
  ) {
    errors.performanceFee = 'Performance fee must be between 0% and 100%';
  }
  if (
    data.managementFee === undefined ||
    data.managementFee < 0 ||
    data.managementFee > 20
  ) {
    errors.managementFee = 'Management fee must be between 0% and 20%';
  }

  return errors;
}

export interface GroupFormInput {
  name: string;
  managerId: string;
  allocationMethod: string;
  minDeposit: number;
  maxClients: number;
}

export function validateGroupForm(
  data: Partial<GroupFormInput>
): Record<string, string> {
  const errors: Record<string, string> = {};

  if (!data.name?.trim()) errors.name = 'Group name is required';
  if (!data.managerId) errors.managerId = 'Assigned Manager is required';
  if (!data.allocationMethod)
    errors.allocationMethod = 'Allocation Method is required';
  if (data.minDeposit === undefined || data.minDeposit < 0) {
    errors.minDeposit = 'Minimum deposit cannot be negative';
  }

  return errors;
}
